import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import any language resources here
// For example:
// import enResources from './locales/en.json';
// import frResources from './locales/fr.json';

const resources = {
  en: {
    translation: {
      // You can include your translations here or import them from separate files
      "Notifications": "Notifications",
      "Mark all as read": "Mark all as read",
      "Missed call": "Missed call"
      // Add more translations as needed
    }
  }
  // Add more languages as needed
  // fr: {
  //   translation: frResources
  // }
};

// Initialize i18next
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en', // fallback language
    interpolation: {
      escapeValue: false // not needed for React as it escapes by default
    },
    react: {
      useSuspense: false // This can help prevent issues during rendering
    },
    initImmediate: false // Initialize synchronously
  });

export default i18n; 